document.addEventListener('DOMContentLoaded', function () {
  const cartForm = document.getElementById('cart');
  const checkoutBtn = document.getElementById('checkout');

  const pickupSelect = document.getElementById('pickup-location'); // hidden select
  const pickupDate = document.getElementById('pickup-date');       // flatpickr text input
  const errorBox = document.getElementById('pickup-error');

  if (!cartForm || !checkoutBtn || !pickupSelect || !pickupDate || !errorBox) return;

  function showError(msg) {
    errorBox.textContent = msg;
    errorBox.style.display = 'block';
    errorBox.setAttribute('role', 'alert');

    // sanft zum Hinweis scrollen
    const top = errorBox.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  function clearError() {
    errorBox.textContent = '';
    errorBox.style.display = 'none';
  }

  function validatePickup() {
    const hasLocation = (pickupSelect.value || '').trim().length > 0;
    const hasDate = (pickupDate.value || '').trim().length > 0;

    if (!hasLocation && !hasDate) {
      return { ok: false, msg: 'Bitte wähle eine Abholfiliale und ein Abholdatum aus.' };
    }
    if (!hasLocation) {
      return { ok: false, msg: 'Es wurde keine Abholfiliale ausgewählt.' };
    }
    if (!hasDate) {
      return { ok: false, msg: 'Es wurde noch kein Abholdatum angegeben.' };
    }
    return { ok: true };
  }

  // Klick auf "Zur Kasse" → prüfen und ggf. melden
  checkoutBtn.addEventListener('click', function (e) {
    const res = validatePickup();
    if (!res.ok) {
      e.preventDefault();
      e.stopPropagation();
      showError(res.msg);
    }
  });

  // Auch Enter/sonstige Submits abfangen
  cartForm.addEventListener('submit', function (e) {
    const res = validatePickup();
    if (!res.ok) {
      e.preventDefault();
      showError(res.msg);
    }
  });

  // Sobald Nutzer etwas auswählt → Meldung weg
  pickupSelect.addEventListener('change', function () {
    if (validatePickup().ok) clearError();
  });
  pickupDate.addEventListener('change', function () {
    if (validatePickup().ok) clearError();
  });
});